export const specials = [
  {
    id: "special-1",
    type: "special",
    title: "科幻电影十年进化史",
    image: "https://readdy.ai/api/search-image?query=futuristic%20retro%20collage%20of%20science%20fiction%20cinema%20motifs%2C%20starships%20planets%20and%20glowing%20circuitry%20in%20deep%20blue%20with%20warm%20orange%20highlights%2C%20cinematic%20editorial%20composition%2C%20highly%20detailed%20digital%20art&width=1200&height=700&seq=special-01-cover&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=epic%20timeline%20of%20science%20fiction%20imagery%20blending%20starships%20and%20planets%20in%20deep%20blue%20space%20with%20warm%20orange%20energy%2C%20cinematic%20wide%20panoramic%20composition%2C%20highly%20detailed%20digital%20matte%20painting&width=1600&height=900&seq=special-01-banner&orientation=landscape",
    year: "2026",
    releaseDate: "2026-06-01",
    region: "影视工厂",
    genres: ["深度解读"],
    cast: "影视工厂编辑部",
    director: "—",
    summary: "从视效的突破到叙事的升华，回顾科幻电影走过的十年关键节点。",
    content: [
      "过去十年，是科幻电影飞速发展的十年。技术的进步让曾经只存在于想象中的画面成为现实。",
      "但真正打动人心的，从来不只是奇观，而是隐藏在宏大设定背后的人文思考。",
      "本专题将带你系统梳理科幻电影的演进脉络，读懂那些影响深远的作品与理念。",
    ],
    tags: ["科幻", "深度解读", "影史"],
    articles: [
      { id: "news-3", title: "科幻题材持续升温，国产工业化制作进入新阶段", summary: "从虚拟拍摄到数字化制片，科幻电影的制作体系正走向成熟。" },
      { id: "movie-1", title: "《星际边界》：当人类走到宇宙的尽头", summary: "一部关于孤独与文明延续的年度科幻力作。" },
      { id: "tv-6", title: "《星际商途》：把商战搬上星际舞台", summary: "用宏大世界观讲述野心与坚守的传奇。" },
    ],
  },
  {
    id: "special-2",
    type: "special",
    title: "悬疑剧的叙事革命",
    image: "https://readdy.ai/api/search-image?query=moody%20noir%20collage%20of%20magnifying%20glass%20clues%20and%20shadowy%20figures%20in%20deep%20blue%20with%20warm%20orange%20accents%2C%20cinematic%20editorial%20composition%2C%20highly%20detailed%20concept%20art&width=1200&height=700&seq=special-02-cover&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=atmospheric%20noir%20scene%20with%20deep%20blue%20fog%20and%20warm%20orange%20street%20lamps%2C%20mysterious%20silhouettes%20and%20clues%2C%20cinematic%20wide%20composition%2C%20highly%20detailed%20photography&width=1600&height=900&seq=special-02-banner&orientation=landscape",
    year: "2026",
    releaseDate: "2026-05-20",
    region: "影视工厂",
    genres: ["深度解读"],
    cast: "影视工厂编辑部",
    director: "—",
    summary: "当观众不再满足于猜凶手，悬疑剧如何在叙事结构上寻找新的突破。",
    content: [
      "悬疑剧的黄金时代正在到来，观众早已习惯了层层反转，也变得更加挑剔。",
      "从非线性叙事到多线并行，创作者们不断重新定义谜题与真相的关系。",
      "本专题聚焦悬疑叙事的革新，解析那些让观众欲罢不能的巧思。",
    ],
    tags: ["悬疑", "叙事", "深度解读"],
    articles: [
      { id: "tv-1", title: "《长夜将明》：冷色调里的缜密推理", summary: "一部被称为年度悬疑黑马的高分剧。" },
      { id: "movie-8", title: "《无声证词》：在沉默中寻找真相", summary: "以克制叙事探讨真相与良知。" },
      { id: "news-2", title: "年度影视大奖提名公布：多部现实主义题材入围", summary: "现实主义与女性叙事成为评委关注重点。" },
    ],
  },
  {
    id: "special-3",
    type: "special",
    title: "华语电影黄金年代回顾",
    image: "https://readdy.ai/api/search-image?query=vintage%20cinema%20collage%20with%20old%20film%20projectors%20tickets%20and%20posters%20in%20warm%20orange%20with%20deep%20blue%20shadows%2C%20nostalgic%20editorial%20composition%2C%20highly%20detailed%20still%20life&width=1200&height=700&seq=special-03-cover&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=nostalgic%20old%20movie%20theatre%20with%20warm%20orange%20marquee%20and%20deep%20blue%20twilight%2C%20vintage%20cars%20and%20posters%2C%20cinematic%20wide%20composition%2C%20highly%20detailed%20photography&width=1600&height=900&seq=special-03-banner&orientation=landscape",
    year: "2026",
    releaseDate: "2026-04-10",
    region: "影视工厂",
    genres: ["影史"],
    cast: "影视工厂编辑部",
    director: "—",
    summary: "回望那些经典辈出的年代，重新理解华语电影的精神底色。",
    content: [
      "每个时代都有自己的银幕记忆，那些经典作品至今仍被反复提起。",
      "它们不仅记录了社会的变迁，也塑造了几代人的审美与情感。",
      "本专题带你重回黄金年代，在旧影像里寻找新的感动。",
    ],
    tags: ["影史", "经典", "回顾"],
    articles: [
      { id: "news-5", title: "经典IP重启引发热议：情怀与创新如何平衡", summary: "当经典被重新讲述，观众在期待与担忧间摇摆。" },
      { id: "movie-3", title: "《城市之光》：写给都市漂流者的情书", summary: "用细腻镜头记录平凡人的冷暖。" },
      { id: "news-6", title: "青年导演扶持计划启动", summary: "为行业注入新鲜血液。" },
    ],
  },
  {
    id: "special-4",
    type: "special",
    title: "幕后：一部电影特效的诞生",
    image: "https://readdy.ai/api/search-image?query=vfx%20studio%20with%20deep%20blue%20holographic%20renders%20and%20warm%20orange%20highlights%2C%20green%20screen%20and%20camera%20gear%2C%20cinematic%20editorial%20composition%2C%20highly%20detailed%20photography&width=1200&height=700&seq=special-04-cover&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=large%20vfx%20production%20stage%20with%20deep%20blue%20lighting%20and%20warm%20orange%20lamps%2C%20motion%20capture%20rig%20and%20camera%20crane%2C%20cinematic%20wide%20composition%2C%20highly%20detailed%20photography&width=1600&height=900&seq=special-04-banner&orientation=landscape",
    year: "2026",
    releaseDate: "2026-03-15",
    region: "影视工厂",
    genres: ["技术"],
    cast: "影视工厂编辑部",
    director: "—",
    summary: "走进特效工作室，看看银幕奇观究竟是如何一步步被创造出来的。",
    content: [
      "特效从来不是简单地堆砌技术，而是服务于故事与情感的表达。",
      "从概念设计到最终合成，一个镜头背后往往凝结着数百人的心血。",
      "本专题将揭开特效制作的神秘面纱，带你理解技术与艺术的结合。",
    ],
    tags: ["特效", "幕后", "技术"],
    articles: [
      { id: "news-8", title: "幕后揭秘：一部电影的特效是这样诞生的", summary: "完整呈现电影特效的制作全流程。" },
      { id: "movie-7", title: "《深海归途》：四年打磨的水下视效", summary: "让观众窥见地球最后的未知疆域。" },
      { id: "news-3", title: "科幻题材持续升温，国产工业化制作进入新阶段", summary: "技术是手段，故事才是核心。" },
    ],
  },
  {
    id: "special-5",
    type: "special",
    title: "都市情感的温柔表达",
    image: "https://readdy.ai/api/search-image?query=warm%20urban%20collage%20of%20city%20windows%20at%20dusk%20in%20deep%20blue%20with%20warm%20orange%20glow%2C%20intimate%20emotional%20mood%2C%20cinematic%20editorial%20composition%2C%20highly%20detailed%20photography&width=1200&height=700&seq=special-05-cover&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=cozy%20city%20apartment%20windows%20glowing%20warm%20orange%20against%20deep%20blue%20evening%2C%20cinematic%20intimate%20wide%20composition%2C%20highly%20detailed%20photography&width=1600&height=900&seq=special-05-banner&orientation=landscape",
    year: "2026",
    releaseDate: "2026-02-20",
    region: "影视工厂",
    genres: ["情感"],
    cast: "影视工厂编辑部",
    director: "—",
    summary: "在快节奏的都市里，影视作品如何捕捉那些细碎而真实的温柔。",
    content: [
      "都市题材从来不缺故事，缺的是对平凡生活的真诚注视。",
      "那些关于孤独、陪伴与和解的瞬间，往往最能击中观众的心。",
      "本专题聚焦都市情感表达，解读那些让人久久回味的细腻时刻。",
    ],
    tags: ["都市", "情感", "治愈"],
    articles: [
      { id: "tv-2", title: "《都市繁花》：当代女性的多面人生", summary: "以精致都市美学勾勒情感群像。" },
      { id: "movie-6", title: "《时光信笺》：跨越时空的温柔通信", summary: "用最朴素的方式讲述遗憾与释怀。" },
      { id: "movie-3", title: "《城市之光》：两个孤独灵魂的相互照亮", summary: "一封写给都市漂流者的情书。" },
    ],
  },
];